import {DataTable} from "../DataTable/DataTable";
import {SiteAssignmentCompanyAssocEntity} from "@ots-frontend/ots-data";
import {DefaultText} from "../../text/DefaultText/DefaultText";
import {useTranslation} from "react-i18next";
import {useDataTableSorter} from "../DataTable/useDataTableSorter";
import {usePagination} from "../DataTable/usePagination";
import {EntityDataTableProps} from "../EntityDataTable/EntityDataTable";

const EMPTY_ARRAY: SiteAssignmentCompanyAssocEntity[] = []

export type SiteAssignmentCompanyAssocDataTableProps = EntityDataTableProps<SiteAssignmentCompanyAssocEntity>

export const SiteAssignmentCompanyAssocDataTable = (props: SiteAssignmentCompanyAssocDataTableProps) => {
  const {
    records: assignments = EMPTY_ARRAY,
    recordsPerPageOptions,
    ...rest
  } = props

  const {t} = useTranslation(["common"]);

  const {
    sortedRecords,
    sortStatus,
    onSortStatusChange,
  } = useDataTableSorter({
    records: assignments,
    sortStatus: {columnAccessor: 'normalPreferenceRank', direction: 'asc'},
  })

  const pagination = usePagination({
    data: sortedRecords,
    recordsPerPageOptions: recordsPerPageOptions,
  });

  return (
    <DataTable
      {...rest}
      {...(pagination ?? {})}
      sortStatus={sortStatus}
      onSortStatusChange={onSortStatusChange}
      columns={[
        {
          title: t("common.entity.siteassignment.table.column.company", "Company"),
          accessor: "company.name",
          width: 100,
          sortable: true,
          render: ({company}) => (
            <DefaultText value={company?.name}/>
          )
        },
        {
          title: t("common.entity.siteassignment.table.column.normalrank", "Normal Rank"),
          accessor: "normalPreferenceRank",
          width: 100,
          sortable: true,
        },
        {
          title: t("common.entity.siteassignment.table.column.servicerank", "Service Rank"),
          accessor: "servicePreferenceRank",
          width: 100,
          sortable: true,
        }
      ]}
    />
  );
};
